/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
import Cart from"cart-store";
$(document).ready(function () {
  $("button.js-qty__adjust.js-qty__adjust--minus").css({
    "pointer-events": "none",
    opacity: "0.8",
  });
  $(document).on("click", "button.js-qty__adjust.js-qty__adjust--plus", function () {
    let textInput = $(this)
      .closest(".product-single__qty-input")
      .find("input#Quantity-1, input#Quantity-ctm-1")
      .val();
    $(this)
      .closest(".product-single__qty-input")
      .find("input#Quantity-1, input#Quantity-ctm-1")
      .val(parseInt(textInput) + 1);
    $("button.js-qty__adjust.js-qty__adjust--minus").css({
      "pointer-events": "auto",
      opacity: "1",
    });
  });
   $(document).on("click", "button.js-qty__adjust.js-qty__adjust--minus", function () {
    let textInput = $(this)
      .closest(".product-single__qty-input")
      .find("input#Quantity-1, input#Quantity-ctm-1")
      .val();
    $(this)
      .closest(".product-single__qty-input")
      .find("input#Quantity-1, input#Quantity-ctm-1")
      .val(parseInt(textInput) - 1);
    let disabled_minus = $(this)
      .closest(".product-single__qty-input")
      .find("input#Quantity-1, input#Quantity-ctm-1")
      .val();
    if (disabled_minus <= 0) {
      $(this).css({
        "pointer-events": "none",
        opacity: "0.8",
      });
    }
  });
 

  $(document).on('click', ".varint_ul.color-options .variant-add", async function (event) {
     let currentQty = $(".product-single__qty-input input#Quantity-1, .product-single__qty-input input#Quantity-ctm-1").val(); 
    
      $(".varint_ul.color-options .variant-add").removeClass("active-variant-add");
      $(this).addClass("active-variant-add");
    
      var selectedColorValue = $(this).closest('.ctWrap').attr('data-color-value');
      // console.log(selectedColorValue);
      var eachDefaultElement = $(this).closest('.new-varint-ul-list-with-default-options').find('.default-product-variant-options-element .product-form__swatch__item--color');
      eachDefaultElement.find('label[data-value="'+selectedColorValue+'"]').trigger('click');
      // console.log(eachDefaultElement);
      setTimeout(() => { // Restore quantity after variant change
      $(".product-single__qty-input input#Quantity-1, .product-single__qty-input input#Quantity-ctm-1").val(currentQty);
    }, 300); 
    
  });

// custom code to match the product card color in a quick view drawer

  $(document).on("click", ".quick-shop__trigger", function (event) {
    event.preventDefault();
    let productCard = $(this).closest(".product-card");
    let activeSwatch = productCard.find(".product-card__swatch__item.is-active variant-swatch");
    let selectedColor = activeSwatch.attr("color-match"); 

    let quickView = productCard.find(".quick-shop__wrapper");
    if (activeSwatch.length > 0 && quickView.length > 0) {
        setTimeout(() => {
            let quickViewSwatches = quickView.find(".varint_ul.color-options li");
            let quickViewSelectedSwatch = quickView.find(".varint_ul.color-options li[data-color-value='"+selectedColor+"']");
            quickViewSwatches.find(".variant-add").removeClass("active-variant-add");
            quickViewSelectedSwatch.find(".variant-add").addClass("active-variant-add");
            $(".current_select_color span").text(selectedColor);
            quickViewSelectedSwatch.find(".variant-add").trigger('click');
        }, 1500);
    }
});

  $("button#submitbutton").click(async function (event) {
    event.preventDefault();
    var itemsList = [];
    var properties = {};
    $.each($('input[name*="properties"]').serializeArray(), function () {
      var name = this.name.replace("properties[", "").replace("]", "");
      properties[name] = this.value;
      console.log(name);
    });

    $(".bundle-qty").each(function () {
      var qty = $(this).val();
      //console.log(qty);
      var variantId_custom = $(this)
        .parents(".ctWrap ")
        .find(".variantId_custom")
        .val();
      if (qty > 0) {
        var item = {};
        item.id = variantId_custom;
        item.quantity = qty;
        if (Object.keys(properties).length > 0) {
          item.properties = properties;
        }
        itemsList.push(item);
      }
    });
    var data = {
      items: itemsList,
    };
    console.log(data);
    await Cart.add(itemsList);
    const drawer_const = document.querySelector(".modal--cart, .popup--cart-notification");
    drawer_const && !drawer_const.shown ? drawer_const.open() : drawer_const && drawer_const.interval && (drawer_const.interval.reset(), drawer_const.interval.start());
    // setTimeout(function() {
    //     $.ajax({
    //         type: 'post',
    //         url: '/cart/add.js',
    //         data: data,
    //         dataType: 'JSON',
    //         success: function(data) {
    //             // setTimeout(function() {
    //             //     theme.runAjaxCart();
    //             //     theme.mfpOpen("cart");
    //             //     $('div#CartContainer').css('display','block');
    //             // }, 100);
    //             window.location.href = '/cart';
    //         }
    //     });
    // }, 500);
    
     
  });
  $(document).on('click', ".onetimeonly", async function (event) {
    event.preventDefault();
    var itemsList = [];
    var properties = {};
    $.each($('input[name*="properties"]').serializeArray(), function () {
      var name = this.name.replace("properties[", "").replace("]", "");
      if(this.value != ''){
        properties[name] = this.value;
      }
      console.log(this.value);
    });

    
    $.each($('select[name*="properties"]').serializeArray(), function () {
      var name = this.name.replace("properties[", "").replace("]", "");
      properties[name] = this.value;
      console.log(this.value);
    });
    $(".bundle-qty2").each(function () {
      var qty = $(this).val();
      var variantId_custom = $(this)
        .parents(".var-2-wrap")
        .find(".variantId_custom2")
        .val();
      if (qty > 0) {
        var item = {};
        console.log('oneTime: ' + qty);
        item.id = variantId_custom;
        item.quantity = qty;
        if (Object.keys(properties).length > 0) {
          item.properties = properties;
        }
        itemsList.push(item);
      }
    });
    console.log('outer');
    console.log(itemsList);
    var data = {
      items: itemsList,
    };
    console.log('inner: ' + data);
    await Cart.add(itemsList);
    const drawer_const = document.querySelector(".modal--cart, .popup--cart-notification");
    drawer_const && !drawer_const.shown ? drawer_const.open() : drawer_const && drawer_const.interval && (drawer_const.interval.reset(), drawer_const.interval.start());
    $(".js-qty__num").each(function () {
        $(this).val(0); // Reset value to 0
    });
    // $.ajax({
    //     type: 'POST',
    //     url: '/cart/add.js',
    //     data: data,
    //     dataType: 'json',
    //     success: function(response) {
    //         // Redirect to cart page immediately after a successful add
    //       theme.mfpOpen("cart");
    //         //window.location.href = '/cart';
    //     },
    //     error: function(error) {
    //         console.error("Error adding to cart:", error);
    //     }
    // });
    // Quick view closed after add to cart code start 
    setTimeout(() => {
        let quickView = $(this).closest(".product-card").find("quick-shop.modal.quick-shop--drawer-dark");
        if (quickView.length) {
            console.log(quickView); 
            quickView.attr("aria-hidden", "true"); 
        }
    }, 500);
     $(document).on('click', ".quick-shop__trigger", function (event) {
        event.preventDefault();
        let quickViewID = $(this).closest(".product-card").find("quick-shop").attr("id"); 
        let quickView = $("#" + quickViewID);
        if (quickView.length) {
            quickView.attr("aria-hidden", "false"); 
        }
    });
    // Quick view closed after add to cart code end 
    
  });

  
   $(".onetimeonly_1").click(async function (event) {
     $(".js-qty__num").each(function () {
        $(this).val(0); // Reset value to 0
    });
   });
});
$(document).on("click", "#removeAll_items", function (event) {
  $(".header-trigger__link").removeClass("js-cart-full");
  $.ajax({
    type: "POST",
    url: "/cart/clear.js",
    data: "",
    dataType: "json",
    success: function () {
      console.log("success");
      $("div#CartContainer").hide();
      $("form.cart-form").hide();
      $("div#EmptyCart").css("display", "block");
      $("#CartCount").text(0);
    },
  });
});



